import { useApi } from "../../../swr/useApi";
import { featuredDealsService, adminFeaturedDealsService } from "../../api_client";
import type { FeaturedDealDto } from "../../../api";

export function useFeaturedDeals() {
  return useApi<FeaturedDealDto[]>("featured-deals", () =>
    featuredDealsService.getFeaturedDeals(),
  );
}

export function useAdminFeaturedDeals() {
  return useApi<FeaturedDealDto[]>("admin-featured-deals", () =>
    adminFeaturedDealsService.adminListFeaturedDeals(),
  );
}
